module.exports = __webpack_public_path__ + "static/media/grey-back-arrow.f74c2dfe.svg";